/* =====================================================================
 * Settings UI types.
 *
 * `SettingsTab` is the canonical union of tab identifiers and lives in
 * `@auw/stores` so it can be referenced by both the UI (here) and the
 * store's `SettingsModalRequest` payload without circular imports.
 * `TABS` / `TabDef` are implementation details of the settings modal
 * UI and intentionally stay in this file — B2B tenants can fork the
 * list to hide tabs per feature flag without mutating shared state.
 * ===================================================================== */
export type { SettingsTab } from '@auw/stores';
import type { SettingsTab } from '@auw/stores';

export interface TabDef {
  id: SettingsTab;
  labelKey: string;
}

export const TABS: TabDef[] = [
  { id: 'profile', labelKey: 'settings:tabs.profile' },
  { id: 'notifications', labelKey: 'common:notifications.title' },
  { id: 'subscription', labelKey: 'settings:tabs.subscription' },
  { id: 'billing', labelKey: 'settings:tabs.billing' },
  { id: 'service', labelKey: 'settings:tabs.service' },
  { id: 'contact', labelKey: 'settings:tabs.contact' },
];
